@if (sharedService.getUser() | async) {
  @if (sharedService.isUserCreditHold) {
    <app-credit-hold-message> </app-credit-hold-message>
  }
}

@if (cards$ | async; as cards) {
  <h3 class="cx-checkout-title d-none d-lg-block d-xl-block">
    {{ 'checkoutAddress.shippingAddress' | cxTranslate }}
  </h3>
  @if (!(isUpdating$ | async)) {
    @if (isAccountPayment || (cards?.length && !addressFormOpened)) {
      <div class="cx-checkout-text">
        <p class="my-3">
          {{ 'checkoutAddress.selectYourDeliveryAddress' | cxTranslate }}
        </p>
      </div>
      @if (!isAccountPayment) {
        <div class="cx-checkout-btns row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <button class="btn btn-block btn-secondary" (click)="showNewAddressForm()">
              {{ 'checkoutAddress.addNewAddress' | cxTranslate }}
            </button>
          </div>
        </div>
      }
      <div class="cx-checkout-body row">
        @if (showAddresses) {
          @for (card of cards; track card; let i = $index) {
            <div class="cx-delivery-address-card col-md-12 col-lg-6">
              <div class="cx-delivery-address-card-inner" (click)="selectAddress(card.address)">
                <cx-card
                  [border]="true"
                  [index]="i"
                  [fitToContainer]="true"
                  [content]="removeNameFromCard(card.card)"
                  (sendCard)="selectAddress(card.address)"
                  >
                </cx-card>
              </div>
            </div>
          }
        } @else {
          <div class="cx-spinner">
            <cx-spinner></cx-spinner>
          </div>
        }
      </div>
      <div class="eta-guide">
        <mat-accordion class="eta-accordion">
          <mat-expansion-panel (opened)="etaPanel = true" (closed)="etaPanel = false" class="eta-panel">
            <mat-expansion-panel-header class="eta-panel-header">
              <mat-panel-title>
                <h3 class="eta-title">Delivery Guideline Information</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (baseSite == EnumCountry.AU) {
              <div class="eta">
                <p class="eta-subtitle">AU</p>
                <p class="eta-description">{{ 'etaGuide.au' | cxTranslate }}</p>
                <ng-container *ngTemplateOutlet="EtaGuideTemplate"></ng-container>
                <p class="eta-hint">{{ 'etaGuide.hint' | cxTranslate }}</p>
              </div>
            }
            @if (baseSite == EnumCountry.NZ) {
              <div class="eta">
                <p class="eta-subtitle">NZ</p>
                <p class="eta-description">{{ 'etaGuide.nzTime' | cxTranslate }}</p>
                <p class="eta-description">{{ 'etaGuide.nz' | cxTranslate }}</p>
                <ng-container *ngTemplateOutlet="EtaGuideTemplate"></ng-container>
                <p class="eta-hint">{{ 'etaGuide.nzLowerNorth' | cxTranslate }}</p>
                <p class="eta-hint">{{ 'etaGuide.nzNWFS' | cxTranslate }}</p>
                <p class="eta-hint">{{ 'etaGuide.nzFSNI' | cxTranslate }}</p>
                <p class="eta-hint">{{ 'etaGuide.nzPD' | cxTranslate }}</p>
                <p class="eta-hint">{{ 'etaGuide.nzInvoice' | cxTranslate }}</p>
              </div>
            }
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="cx-checkout-btns row">
        <div class="col-md-12 col-lg-6">
          <button class="cx-btn btn btn-block btn-secondary" (click)="back()">
            {{ backBtnText | cxTranslate }}
          </button>
        </div>
        <div class="col-md-12 col-lg-6">
          <button
            class="cx-btn btn btn-block btn-primary"
            [disabled]="!(selectedAddress$ | async)?.id"
            (click)="next()"
            >
            {{ 'common.continue' | cxTranslate }}
          </button>
        </div>
      </div>
    } @else {
      @if (cards.length) {
        <cx-address-form
          [showTitleCode]="true"
          (backToAddress)="hideNewAddressForm(false)"
          (submitAddress)="addAddress($event)"
        ></cx-address-form>
      } @else {
        <cx-address-form
          [showTitleCode]="true"
          [setAsDefaultField]="!isGuestCheckout"
          [addressData]="selectedAddress"
          cancelBtnLabel="{{ backBtnText | cxTranslate }}"
          (backToAddress)="hideNewAddressForm(true)"
          (submitAddress)="addAddress($event)"
          >
        </cx-address-form>
      }
    }
  } @else {
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  }
}

<ng-template #EtaGuideTemplate>
  @if (etaGuide$ | async; as EtaGuide) {
    @if (EtaGuide.list && EtaGuide.table) {
      <table class="eta-table d-none d-sm-table">
        <thead>
          @for (key of EtaGuide.table.keys; track key) {
            <th scope="col">{{ key }}</th>
          }
        </thead>
        <tbody>
          @for (rows of EtaGuide.table.values; track rows) {
            <tr>
              @for (value of rows; track value) {
                <td>
                  {{ value }}
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      <div class="eta-list d-sm-none">
        @for (itemList of EtaGuide.list; track itemList) {
          <div class="eta-list">
            <p class="eta-list-title">{{ itemList.key }}</p>
            <p class="eta-list-value">{{ itemList.value }}</p>
          </div>
        }
      </div>
    }
  }
</ng-template>
